import { cn } from '@/lib/cn'

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  description?: string
  size?: 'sm' | 'md'
  disabled?: boolean
}

export function Switch({ checked, onChange, label, description, size = 'md', disabled }: SwitchProps) {
  const trackSize = size === 'sm' ? 'w-8 h-4' : 'w-11 h-6'
  const thumbSize = size === 'sm' ? 'h-3 w-3' : 'h-5 w-5'
  const translate = size === 'sm' ? 'translate-x-4' : 'translate-x-5'

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn(
          'relative inline-flex shrink-0 cursor-pointer rounded-full transition-colors duration-200',
          trackSize,
          checked ? 'bg-primary-600' : 'bg-neutral-300',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
      >
        <span
          className={cn(
            'pointer-events-none inline-block rounded-full bg-white shadow-sm transition-transform duration-200',
            thumbSize,
            'mt-0.5 ml-0.5',
            checked ? translate : 'translate-x-0'
          )}
        />
      </button>
      {(label || description) && (
        <div>
          {label && <span className="text-sm font-medium text-neutral-900">{label}</span>}
          {description && <p className="text-xs text-neutral-500">{description}</p>}
        </div>
      )}
    </div>
  )
}
